import * as PathNavigation from '../PathNavigation'
import { ReactComponent as IconCuradoria } from '../../images/header/icon_curadoria.svg'
import { ReactComponent as IconIneditos } from '../../images/header/icon_ineditos.svg'

export const LOGIN_INFO = {
  'path': PathNavigation.login,
  'text': 'Login',
}

export const SUBSCRIBERS_SUPPORT_INFO = {
  'path': 'https://duvidas.taglivros.com/',
  'text': 'Suporte para associados',
}

export const SUBSCRIBE_BUTTON_INFO = {
  'path': {
    'home': PathNavigation.alternativeCheckout + '/',
    'remaining': PathNavigation.alternativeCheckout,
    'clubSubscriptionAnchor': PathNavigation.subscriptionAnchor,
    'absoluteClubSubscriptionAnchor': {
      'curadoria': `${PathNavigation.curadoria}${PathNavigation.subscriptionAnchor}`,
      'ineditos': `${PathNavigation.ineditos}${PathNavigation.subscriptionAnchor}`,
    },
  },
  'text': {
    'home': 'Assine',
    'remaining': 'Assine',
  },
}

export const LINKS = [
  {
    'icon': IconIneditos,
    'isExternal': false,
    'path': PathNavigation.ineditos,
    'text': 'Inéditos',
  },
  {
    'icon': IconCuradoria,
    'isExternal': false,
    'path': PathNavigation.curadoria,
    'text': 'Curadoria',
  },
  {
    'icon': false,
    'isExternal': false,
    'path': PathNavigation.kitsPassados,
    'text': 'Kits passados',
  },
  {
    'icon': null,
    'isExternal': true,
    'path': PathNavigation.lpBookster,
    'text': 'Clube Bookster',
  },
  {
    'icon': null,
    'isExternal': true,
    'path': PathNavigation.lpAtlasDoFeminino,
    'text': 'Clube Marcela Ceribelli',
  },
  {
    'icon': null,
    'isExternal': true,
    'path': PathNavigation.livraria,
    'text': 'Livraria',
  },
]
